import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=5360b0e4&"
import script from "./bottom.vue?vue&type=script&lang=js&"
export * from "./bottom.vue?vue&type=script&lang=js&"
import style0 from "./bottom.vue?vue&type=style&index=0&id=5360b0e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports